import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const FaceWoman = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M7.625 6.694S12 5.652 12 3.569c0 2.083 4.375 3.125 4.375 3.125M7.882 5.137C7.882 3.404 9.725 2 12 2c2.274 0 4.118 1.404 4.118 3.137m1.295 8.506a1 1 0 0 1 .187-.021c.31.026.597.17.798.4.202.231.302.529.278.83.023.301-.077.599-.278.829s-.488.374-.798.4a.97.97 0 0 1-.56-.18c-.795 2.524-3.39 5.066-5.04 5.066-1.651 0-4.241-2.544-5.035-5.066a.97.97 0 0 1-.56.18 1.2 1.2 0 0 1-.799-.4 1.13 1.13 0 0 1-.278-.829c-.023-.3.076-.598.276-.828s.486-.374.796-.402q.094 0 .186.021m3.695 3.9c.192.267.45.482.751.625.3.144.633.213.968.2.335.013.668-.056.968-.2.3-.143.559-.358.751-.624m-8.49-5.348A2.5 2.5 0 0 1 5 11.176c0-2.252 3.134-4.078 7-4.078s7 1.826 7 4.078a2.5 2.5 0 0 1-.23 1.02q-.057.132-.126.255-1.221.114-2.477.116c-7.234 0-7.686-2.953-7.686-2.953s.152 2.345-1.542 2.345m-.703 5.457q-1.045.923-.824 1.434c.152.353.672.362.824.717s-.128.814-.824 1.433m12.352-3.584q1.045.923.824 1.434c-.152.353-.672.362-.824.717s.128.814.824 1.433m-8.921-7.238v.905m4.666-.905v.905"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(FaceWoman) as SvgIcon;
export { ForwardRef as ReactComponent };
